import styled from 'styled-components';

import {
  Rewards as DefaultRewards,
  PointsText,
  StyledPointsIcon,
} from './transaction.styled.default';

export * from './transaction.styled.default';

export const IconWrapper = styled.div<{ $pointsEarned: boolean }>`
  display: flex;
  align-items: center;
  ${StyledPointsIcon} path {
    fill: ${props => (props.$pointsEarned ? Styles.color.loyaltyHighlight : Styles.color.black)};
  }
  ${PointsText} {
    color: ${props => (props.$pointsEarned ? Styles.color.loyaltyHighlight : Styles.color.black)};
  }
`;

export const Rewards = styled(DefaultRewards)`
  padding-inline-start: 1rem;

  ${Styles.mobile} {
    padding-inline-start: 0.5rem;
  }
`;
